var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var TrackingAPI = /** @class */ (function (_super) {
    __extends(TrackingAPI, _super);
    function TrackingAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrackingAPI.prototype.startShift = function (input) { return this.fetcher.post("/api/tracking/mechanic/start-shift", input); };
    TrackingAPI.prototype.startTask = function (input) { return this.fetcher.post("/api/tracking/mechanic/start-task", input); };
    TrackingAPI.prototype.cancelTask = function (input) { return this.fetcher.post("/api/tracking/mechanic/cancel-task", input); };
    TrackingAPI.prototype.endTask = function (input) { return this.fetcher.post("/api/tracking/mechanic/end-task", input); };
    TrackingAPI.prototype.endShift = function (input) { return this.fetcher.post("/api/tracking/mechanic/end-shift", input); };
    TrackingAPI.prototype.getActiveShift = function () { return this.fetcher.get("/api/tracking/mechanic/get-active-shift"); };
    return TrackingAPI;
}(SubAPI));
export { TrackingAPI };
